<template>
<v-app>
  <v-content>
  <v-container fluid ma-0 pa-0 v-resize="onResize">
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="12000"
      absolute
      >
      {{ message }}
      <v-btn
        dark
        flat
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-img src="../../static/img/coffee_bg.png" :width="x" :height="y" class="bgimage">
        <nav class="navbar navbar-light" style="height: 10px;">
          <a class="navbar-brand" href="#">
            <img src="../../static/img/logo.svg" width="60" height="40" class="d-inline-block align-top" alt="">
            <div style="display: inline-block; padding-left: 5px; color: #00513B;font-weight: 700;">
              <span color="primary--text"> KENYA COFFEE </span>
            </div>
          </a>
          <div id="navbarNav" style="margin-right: 200px;">
          <ul class="nav justify-content-end">
            <li class="nav-item">
              <a class="nav-link links" href="/">Home</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://onlinebanking.co-opbank.co.ke/" target="_blank">Co-op Online</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.nairobicoffeeexchange.co.ke/" target="_blank">NCE</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.agricultureauthority.go.ke/" target="_blank">AFA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links" href="https://www.cma.or.ke/" target="_blank">CMA</a>
            </li>
            <li class="nav-item">
              <a class="nav-link links active" href="/login">Login</a>
            </li>
          </ul>
        </div>
        </nav>
      <v-layout align-center justify-center row  fill-height wrap>
          <v-flex xs8 class="loginfront">
            <v-container fluid>
              <v-layout row wrap>
              <v-flex xs12 sm12>
                <p class="textbold">Submit a question to our support team</p>
                <p class="textlight">Our dedicated staff will respond as soon as possible or within 48 hours</p>
              </v-flex>
              <v-flex xs12 sm5>
                <div class="form-group">
                  <label class="labeltext">Company Name</label>
                  <input v-model="contact.companyName" type="text" class="form-control" required>
                </div>
              </v-flex>
              <v-flex xs12 sm5 offset-sm-1>
                <div class="form-group">
                  <label class="labeltext">Contact Person Name</label>
                  <input v-model="contact.personName" type="text" class="form-control" required>
                </div>
              </v-flex>
              <v-flex xs12 sm5>
                <div class="form-group">
                  <label class="labeltext">Phone Number</label>
                  <input v-model="contact.phoneNumber" type="text" class="form-control" required>
                </div>
              </v-flex>
              <v-flex xs12 sm5 offset-sm-1>
                <div class="form-group">
                  <label class="labeltext">Email</label>
                  <input v-model="contact.email" type="text" class="form-control" required>
                </div>
              </v-flex>
              <v-flex xs12 sm11>
                <div class="form-group">
                  <label class="labeltext">Subject</label>
                  <input v-model="contact.subject" type="text" class="form-control" required>
                </div>
              </v-flex>
              <v-flex xs12 sm11>
                <div class="form-group">
                  <label class="labeltext">Message</label>
                  <textarea v-model="contact.message" class="form-control" rows="4" required></textarea>
                </div>
              </v-flex>

              <v-flex xs11>
                <v-card-actions>
                  <v-btn  class="btn"> Cancel </v-btn>
                  <v-spacer> </v-spacer>
                  <v-btn medium color="secondary" class="btn" @click="submitMessage"> Submit </v-btn>
                </v-card-actions>
              </v-flex>
              </v-layout>
            </v-container>
          </v-flex>
      </v-layout>
    </v-img>
  </v-container>
</v-content>
</v-app>
</template>
<script>
import axios from 'axios'
import config from '../config'

export default {
  name: 'contactus',
  data (router) {
    return {
      section: 'Contact Us',
      message: '',
      snackbar: false,
      x: 0,
      y: 0,
      contact: {}
    }
  },
  mounted () {
    this.onResize()
  },
  methods: {
    onResize () {
      this.x = window.innerWidth
      this.y = window.innerHeight
    },
    submitMessage () {
      const url = config.serverURI + '/contactus/new'
      axios.post(url, this.contact)
        .then(response => {
          if (response.data.error !== false) {
            this.message = response.data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            console.log('Error is ' + this.message)
            return
          }
          this.message = response.data.message
          this.snackbar = true
          this.snackbarColor = 'primary'
        })
        .catch(error => {
          console.log('error', error.response)
          this.message = error.response.message
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    }
  }
}

</script>
<style scoped>
.loginfront {
  background: #000000B2 0% 0% no-repeat padding-box;
  padding-left: 40px;
}
.links {
  padding-left: 30px;
  padding-right: 30px;
  color: #00513B;
  font-size: 14px;
  font-weight: 600;
  font-style:"Brandon Grotesque";
}
.active {
  width: 150px;
  background-color: #7BC243;
  text-align: center;
  border-radius: 5px 5px 5px 5px;
}
.textbold {
  line-height: 80%;
  color: white;
  font-size: 16px;
  font-style: "Brandon Grotesque";
  font-weight: 500;
}
.textlight {
  line-height: 80%;
  color: white;
  font-size: 14px;
  font-style: "Brandon Grotesque";
  font-weight: 300;
}
.labeltext {
  color: white;
}
.form-control {
  background: #000000 0% 0% no-repeat padding-box;
  color: white;
  font-size: 14px;
}
.btn {
  font-weight: 700;
  border-radius: 8px;
}
</style>
